import React, { useEffect } from "react";
import { theme, Typography } from "antd";
import {
  CopyOutlined,
  ExclamationCircleOutlined,
  ExperimentOutlined,
} from "@ant-design/icons";
import { CustomTooltip } from "./CustomTooltip";

interface Props {
  title?: string;
  description?: string;
  children?: React.ReactNode;
}

export function TemplatePill({
  title = "Template",
  description = "This is a template. To customize it, please start by duplicating it.",
  children,
}: Props) {
  const { token } = theme.useToken();

  if (!token) {
    return null;
  }

  return (
    <CustomTooltip
      content={
        <div style={{ padding: "16px", maxWidth: "320px" }}>
          <div
            style={{
              marginBottom: "12px",
              fontWeight: 600,
              fontSize: "14px",
              color: token.colorText,
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <ExclamationCircleOutlined
              style={{ fontSize: "16px", opacity: 0.75 }}
            />
            {title}
          </div>
          <div
            style={{
              fontSize: "13px",
              color: token.colorTextSecondary,
              lineHeight: "1.5",
            }}
          >
            <Typography.Text>{description}</Typography.Text>
          </div>
          {children && (
            <>
              <div
                style={{
                  height: "1px",
                  background: token.colorBorderSecondary,
                  margin: "12px 0",
                }}
              />
              <div
                style={{
                  fontSize: "13px",
                  color: token.colorText,
                  lineHeight: "1.5",
                }}
              >
                {children}
              </div>
            </>
          )}
        </div>
      }
    >
      <div
        className="template-pill"
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "4px",
          padding: "8px 16px",
          borderRadius: "16px",
          fontSize: "12px",
          fontWeight: 500,
          color: token.colorPrimary,
          background: token.colorPrimaryBg,
          border: `1px solid ${token.colorPrimaryBorder}`,
          cursor: "help",
          transition: "all 0.2s ease",
          userSelect: "none",
        }}
      >
        <style>
          {`
            .template-pill:hover {
              background: ${token.colorPrimaryBgHover};
              border-color: ${token.colorPrimaryBorderHover};
            }
          `}
        </style>
        <ExclamationCircleOutlined style={{ fontSize: "12px" }} />
        Template
      </div>
    </CustomTooltip>
  );
}
